import useDeleteClientUser from './functions/useDeleteClientUser';
import useDownloadExcel from './functions/useDownloadExcel';
import useLoadClientUsers from './functions/useLoadClientUsers';
import usePageSearches from './functions/usePageSearches';

export default function useClientUsers() {
  const {
    clientUsers,
    isLoadLoading,
    apiFetched,
    handleTryAgain,
    loadClientUsers,
    filteredClientUsers,
    setFilteredClientUsers
  } = useLoadClientUsers();

  const {
    isDeletingClientUser,
    deleteModalShow,
    clientUserBeingRemoved,
    deleteClientUser,
    handleOpenDeleteModal,
    setDeleteModalShow,
  } = useDeleteClientUser({ loadClientUsers });

  const {
    handleChangeSearchTerm,
    searchTerm,
  } = usePageSearches({ setFilteredClientUsers, clientUsers });

  const { downloadExcel } = useDownloadExcel({ fullUsers: clientUsers });

  const isLoading = isLoadLoading || isDeletingClientUser;

  return {
    filteredClientUsers,
    clientUsers,
    isLoading,
    apiFetched,
    handleTryAgain,
    clientUserBeingRemoved,
    deleteClientUser,
    handleChangeSearchTerm,
    searchTerm,
    deleteModalShow,
    handleOpenDeleteModal,
    setDeleteModalShow,
    downloadExcel,
  };
}
